import React from 'react';

import { AGE_CHART } from 'constants/charts';
import ChartReport from 'components/charts/Chart';

const AgeGroupAnswerReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ChartReport
        titleText="How did each age-group answer the question?"
        chartType="bar"
        stacked
        legendConfig={{
          align: 'right',
          verticalAlign: 'top',
          layout: 'vertical',
          itemMarginTop: 5,
        }}
        category="age_range"
        colors={AGE_CHART}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        containerClassName="w-100"
      />
    </div>
  );
};

export default AgeGroupAnswerReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/ageGroupAnswerReport.js